import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import { routes } from "./routes";

interface HomeHealthRouteGuardProps {
  children: ReactNode;
}

export const HomeHealthRouteGuard: FC<HomeHealthRouteGuardProps> = ({
  children,
}) => {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  const { patients } = useAppSelector((state) => state.homehealth);

  // If user has homeHealthId, they should only be able to access patient profile
  if (user?.homeHealthId) {
    // Allow access to patient profile routes
    if (location.pathname.startsWith("/patient-profile")) {
      return <>{children}</>;
    }

    // Redirect to patient profile for all other routes
    // Use the patientId from Redux if available, otherwise fall back to homeHealthId
    const redirectId = patients.find(
      (p: any) => p._id === user.homeHealthId
    )?.patient_id;

    if (redirectId) {
      return (
        <Navigate
          to={routes.patientProfile.path.replace(
            ":patientId",
            String(redirectId)
          )}
          replace
        />
      );
    }
  }

  // For non-home health users, allow access to all routes
  return <>{children}</>;
};
